import axios from 'axios';
import { Article } from '../../data_types';

const BASE_URL = process.env.REACT_APP_ARTICLES_BASE_URL as string;

if (!BASE_URL) {
    throw new Error('REACT_APP_ARTICLES_BASE_URL is not defined in the environment variables');
}

export const fetchArticles = async (): Promise<{ articles: Article[], articlesPerRow: number }> => {
    try {
        const response = await axios.get<{ articles: Article[], articlesPerRow: number }>(BASE_URL, {
            withCredentials: true // Include credentials in the request
        });
        return response.data;
    } catch (error: any) {
        console.error('Failed to fetch articles:', error.message);
        throw new Error('Failed to fetch articles');
    }
};

export const addArticle = async (newArticle: Article): Promise<Article> => {
    try {
        const response = await axios.post<Article>(BASE_URL, newArticle, {
            withCredentials: true // Include credentials in the request
        });
        return response.data;
    } catch (error) {
        throw new Error('Failed to add article');
    }
};
